import type { SupportedStorage } from '@supabase/supabase-js';

/**
 * Supabase oturumunun durduğu yer. Web'de supabase-js'in varsayılanı
 * (localStorage); mobilde telefonun güvenli deposu (Android Keystore,
 * mobile/src/shims/authStorage.ts).
 */
export const authStorage: SupportedStorage | undefined = undefined;
